import { styled } from '@linaria/react';
import { colors, fonts, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
`;

export const TextContainer = styled.div`
  font-family: ${fonts.body};
  color: ${semantic.text.primary};
  line-height: 1.6;

  &[data-clamped='true'] {
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-orient: vertical;
    overflow: hidden;
    /* line-clamp is applied via inline CSS variable */
    -webkit-line-clamp: var(--max-lines, 4);
  }
`;

export const ToggleButton = styled.button`
  display: inline;
  align-self: flex-start;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: inherit;
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.primary};
  text-decoration: underline;
  line-height: 1.6;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
    border-radius: 2px;
  }

  &:hover {
    opacity: 0.85;
  }
`;
